import { authorizationAxios, instance } from './instance';
import type { FormData, ResetPassword, RestorePassword } from 'src/types/auth.types';
import type { AxiosResAuthLoginType, AxiosResAuthUserType } from 'src/types/api.types';
import { LocalStorageService, ACCESS_TOKEN_KEY } from 'src/utils/localstorage';
import { AxiosError, isAxiosError } from 'axios';

enum apiReq {
  User = 'auth/me',
  SignIn = 'auth/login',
  Logout = 'auth/logout',
  Reset = 'auth/password/reset',
  Restore = 'auth/password/restore',
}

const authLogin = async (data: FormData, rememberMe: boolean) => {
  const storage = new LocalStorageService();
  try {
    const response: AxiosResAuthLoginType = await instance.post(apiReq.SignIn, data);
    authorizationAxios(response.data.access_token);
    storage.setItem(ACCESS_TOKEN_KEY, response.data.access_token);
    return response;
  } catch (err) {
    if (isAxiosError(err)) throw new AxiosError(err.message);
  }
};

const authUser = async () => {
  const storage = new LocalStorageService();
  const access_token = storage.getItem(ACCESS_TOKEN_KEY);
  try {
    if (access_token) {
      authorizationAxios(access_token);
      const response: AxiosResAuthUserType = await instance(apiReq.User);
      return response;
    }
  } catch (err) {
    if (access_token) storage.removeItem(ACCESS_TOKEN_KEY);
    if (isAxiosError(err)) throw new AxiosError(err.message);
  }
};

const authLogout = () => {
  const storage = new LocalStorageService();
  instance.post(apiReq.Logout);
  authorizationAxios(null);
  storage.removeItem(ACCESS_TOKEN_KEY);
};

const authResetPassword = async (data: ResetPassword) => {
  try {
    const response = await instance.post(apiReq.Reset, data);
    return response;
  } catch (err: any) {
    if (isAxiosError(err)) throw new AxiosError((err?.response?.data?.details || [])[0]?.message);
  }
};

const authRestorePassword = async (data: RestorePassword) => {
  try {
    const response = await instance.post(apiReq.Restore, data);
    return response;
  } catch (err) {
    if (isAxiosError(err)) throw new AxiosError(err.message);
  }
};

export { authLogin, authUser, authLogout, authResetPassword, authRestorePassword };
